import React, {useRef, useState} from 'react';

export default function MediaUploadPanel({
    accept = '',
    api,
    onUpload,
    onClose,
}) {
    const inputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [currentName, setCurrentName] = useState('');
    const [error, setError] = useState('');

    const uploadFiles = async files => {
        if (!files.length || uploading) {
            return;
        }

        setUploading(true);
        setError('');
        try {
            for (const file of files) {
                setCurrentName(file.name);
                setProgress(0);
                const uploaded = await api.upload(file, setProgress);
                onUpload(uploaded);
            }
            if (inputRef.current) {
                inputRef.current.value = '';
            }
            onClose();
        } catch (uploadError) {
            setError(uploadError.message);
        } finally {
            setUploading(false);
            setCurrentName('');
        }
    };

    return (
        <div className="media-system-upload" role="region" aria-label="Upload media">
            <div
                className={`media-system-dropzone ${dragging ? 'is-dragging' : ''}`}
                onDragEnter={event => {
                    event.preventDefault();
                    setDragging(true);
                }}
                onDragOver={event => event.preventDefault()}
                onDragLeave={() => setDragging(false)}
                onDrop={event => {
                    event.preventDefault();
                    setDragging(false);
                    uploadFiles(Array.from(event.dataTransfer.files || []));
                }}
            >
                <i className="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                <strong>Drop files here or choose from your device</strong>
                <span>Images, video, audio, PDFs, and other seller files are supported.</span>
                <input
                    ref={inputRef}
                    type="file"
                    multiple
                    accept={accept}
                    disabled={uploading}
                    onChange={event => uploadFiles(Array.from(event.target.files || []))}
                />
            </div>

            {uploading && (
                <div className="media-system-upload-progress" aria-live="polite">
                    <span>Uploading {currentName}</span>
                    <progress value={progress} max="100">{progress}%</progress>
                    <strong>{progress}%</strong>
                </div>
            )}
            {error && <p className="flash error" role="alert">{error}</p>}
        </div>
    );
}
